<template>
    <div>
        <a-row :gutter="40">
            <a-col :span="12">
                <div class="left">
                    <h1>Safeguarding</h1>

                    <p>
                        Report safeguarding concerns to your DSL with automatic writeback to safeguarding systems (MyConcern/CPOMS) 
                    </p>

                    <p>
                        Instantly notify the DSL, ensuring immediate visibility and enabling 'in-the-moment' support. This provides a robust and unified approach to safeguarding across the institution. With built-in protocols and step-by-step guidance, staff are empowered to handle a wide array of scenarios consistently and effectively. Our real-time evidencing feature captures crucial information, providing robust corroboration. 
                    </p>

                    <p>
                        Eliminates cumbersome post-incident paperwork, and enable school leadership to make informed, data-driven decisions while supporting optimal safeguarding practices.
                    </p>

                    <p>
                        <a @click.prevent="$emit('calendly')" href="#">Fancy a chat? Book in time with us here.</a>
                    </p>
                </div>
            </a-col>
            <a-col :span="12">
                <div class="right">
                    <img src="/landing/safeguarding.png" alt="">
                </div> 
            </a-col>
        </a-row>
    </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.left {
    background: #fff;
    padding: 22px 30px;

    h1 {
        font-size: 1.5em;
        margin-bottom: 20px;
    }
}

.right {
    // max-height: 100%;
    text-align: center;
    img {
        max-width: 75% !important;
        margin-left: auto;
        margin-right: auto;
    }
}
</style>